export * from "./order.constants";
export * from "./global.constants";
export * from "./serverResponse/serverResponse.constants";
export * from "./currency.constants";

export const globalConstants = {
  SUCCESS: "_SUCCESS",
  FAILURE: "_FAILURE",
  REQUEST: "_REQUEST",
  SPINNER_ACTIVATE: "SPINNER_ACTIVATE",
  SPINNER_DEACTIVATE: "SPINNER_DEACTIVATE",
  GLOBAL_SPINNER_ACTIVATE: "GLOBAL_SPINNER_ACTIVATE",
  GLOBAL_SPINNER_DEACTIVATE: "GLOBAL_SPINNER_DEACTIVATE",
  SHIPPING_SPINNER_ACTIVATE: "SHIPPING_SPINNER_ACTIVATE",
  SHIPPING_SPINNER_DEACTIVATE: "SHIPPING_SPINNER_DEACTIVATE",
  INITIAL_STATE: "INITIAL_STATE",
  BUTTON_SPINNER_DEACTIVATE: "BUTTON_SPINNER_DEACTIVATE",
  BUTTON_SPINNER_ACTIVATE: "BUTTON_SPINNER_ACTIVATE",
  GLOBAL_PAYMENT_ACTIVATION: "GLOBAL_PAYMENT_ACTIVATION",
};

export const environmentConstants = {
  DEVELOPMENT: "development",
};

export const customerConstants = {
  GUEST: "Guest",
};
